import { usePermissions } from '../../contexts/PermissionContext';

/** Activity key for the Continuous Monitoring rule define/run gate (Phase 105, Decision A). */
export const CMG_RULES_ACTIVITY = 'CMG_RULES';

/**
 * UX-only predicate — mirrors the backend require_permission('CMG_RULES','view+modify')
 * define gate. The backend 403 is the authoritative gate (Phase 105 D-02); this only
 * decides whether to RENDER create/edit/delete affordances.
 *
 * Note: This is a UX convenience only — the backend remains the authoritative gate.
 */
export function useCanDefineRules(): boolean {
  const { check } = usePermissions();
  return check(CMG_RULES_ACTIVITY, 'view+modify').allowed;
}

/** Activity key for the Continuous Monitoring anomaly triage gate (Phase 105, R18). */
export const CMG_EVENTS_ACTIVITY = 'CMG_EVENTS';

/**
 * UX-only predicate — mirrors the backend require_permission('CMG_EVENTS','view+modify')
 * triage gate (Plan 11). Triage is a WRITE action, so this checks the 'view+modify'
 * extent (NOT 'view' — read-only viewers must not see triage controls). The backend
 * 403 is the authoritative gate; this only decides whether to RENDER the disposition
 * affordances (Triage button + modal).
 *
 * Note: This is a UX convenience only — the backend remains the authoritative gate.
 */
export function useCanTriageEvents(): boolean {
  const { check } = usePermissions();
  return check(CMG_EVENTS_ACTIVITY, 'view+modify').allowed;
}
